module.exports = __webpack_public_path__ + "static/media/news-9-aug.2b7a9fc0.png";